import { render, staticRenderFns } from "./CardStyle3.vue?vue&type=template&id=0fb34509&scoped=true&"
import script from "./CardStyle3.vue?vue&type=script&lang=js&"
export * from "./CardStyle3.vue?vue&type=script&lang=js&"
import style0 from "./CardStyle3.vue?vue&type=style&index=0&id=0fb34509&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb34509",
  null
  
)

export default component.exports